import * as React from "react";
const Svg16PxCustomModel = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", "data-name": "Layer 1", viewBox: "0 0 16 16", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m7.67 1.56 4.67 2.69v2.64l-.63 1.7-.1.1-.09.03V5.2l-3.44 2v3.96l.8-.47.6.6-1.82 1.05-4.67-2.69v-5.4zM3.83 5.2v3.97l3.44 1.98V7.18zm3.84-2.69L4.24 4.49l3.43 1.98 3.42-1.98zM13 7.65l2.37 2.37-1.43.54-.39.39-.79 2.36-3.04-3.04 2.36-.79.39-.39zm-3.86 6.79-.54-.54 1.72-1.72.54.54z", style: {
  fill: "currentColor",
  fillRule: "evenodd"
} }));
export default Svg16PxCustomModel;
